import { render } from "./InventoryModal.vue?vue&type=template&id=5cd3a5a7"
import script from "./InventoryModal.vue?vue&type=script&lang=js"
export * from "./InventoryModal.vue?vue&type=script&lang=js"

import "./InventoryModal.vue?vue&type=style&index=0&id=5cd3a5a7&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__